import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import api from '../utils/api';
import '../styles/global.css';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const { register, handleSubmit, watch, formState: { errors } } = useForm();

  const onSubmit = async ({ password }) => {
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      setDone(true);
      toast.success('Password updated successfully!');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Reset failed. Please request a new link.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) return (
    <div className="loading-screen">
      Invalid reset link. <Link to="/login" style={{ color: 'var(--teal)', marginLeft: 8 }}>Go to login</Link>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div className="topbar">
        <div className="topbar-logo"><div className="topbar-logo-dot" />Affordable Telecom LLC</div>
      </div>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ width: '100%', maxWidth: 420 }}>
          {!done ? (
            <>
              <div style={{ textAlign: 'center', marginBottom: 32 }}>
                <h1 style={{ fontSize: 24, fontWeight: 800, color: 'var(--navy)', marginBottom: 6 }}>Set new password</h1>
                <p style={{ color: 'var(--text-sub)', fontSize: 14 }}>Choose a new password for your account.</p>
              </div>
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                      <label className="form-label" htmlFor="new-password">New password</label>
                      <input id="new-password" type="password" className={`form-input${errors.password ? ' error' : ''}`}
                        placeholder="At least 8 characters"
                        {...register('password', { required: true, minLength: 8 })} />
                      {errors.password && <div className="form-error">Minimum 8 characters</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label" htmlFor="confirm-password">Confirm new password</label>
                      <input id="confirm-password" type="password" className={`form-input${errors.confirm ? ' error' : ''}`}
                        placeholder="Repeat your password"
                        {...register('confirm', {
                          required: true,
                          validate: val => val === watch('password') || 'Passwords do not match'
                        })} />
                      {errors.confirm && <div className="form-error">{errors.confirm.message}</div>}
                    </div>
                    <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
                      {loading ? 'Updating...' : 'Update Password'}
                    </button>
                  </form>
                </div>
              </div>
            </>
          ) : (
            <div className="card">
              <div className="card-body" style={{ textAlign: 'center', padding: 32 }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>✅</div>
                <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--navy)', marginBottom: 8 }}>Password updated!</h2>
                <p style={{ color: 'var(--text-sub)', fontSize: 14, marginBottom: 20 }}>You can now sign in with your new password.</p>
                <button className="btn btn-primary" style={{ width: '100%' }} onClick={() => navigate('/login')}>
                  Go to sign in
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
